import { render, staticRenderFns } from "./BayItemFooter.vue?vue&type=template&id=a09a1a34&scoped=true&"
import script from "./BayItemFooter.vue?vue&type=script&lang=js&"
export * from "./BayItemFooter.vue?vue&type=script&lang=js&"
import style0 from "./BayItemFooter.vue?vue&type=style&index=0&id=a09a1a34&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09a1a34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\web\\V-LAB\\project\\bayes-vue2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a09a1a34')) {
      api.createRecord('a09a1a34', component.options)
    } else {
      api.reload('a09a1a34', component.options)
    }
    module.hot.accept("./BayItemFooter.vue?vue&type=template&id=a09a1a34&scoped=true&", function () {
      api.rerender('a09a1a34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BayItem/BayItemFooter.vue"
export default component.exports